<div class="banner">
  <div class="content">
    <h1>Get in Touch</h1>
    <p>
      We’re here to help! Whether you have questions about our products, need
      assistance with an order, or just want to say hello, we’d love to hear
      from you.
    </p>
  </div>
</div>

<article>
  <ul>
    <li>
      <h3><mat-icon fontIcon="email"></mat-icon> Email Us</h3>
      <a href="mailto:{{email}}" target="_blank">{{email}}</a>
      <p>
        For order inquiries, shipping questions, returns, or general support.
      </p>
    </li>
    <li>
      <h3>
        <mat-icon fontIcon="thumb_up"></mat-icon> Follow
        Us on Social Media
      </h3>

      <a href="{{ig}}" target="_blank" rel="noopener noreferrer"><img src="/images/icons/instagram.webp" width="18"
          height="18" alt="Instagram" />@lace.liora</a>
      <a href="{{facebook}}" target="_blank" rel="noopener noreferrer" style="margin-top: 5px;"><img
          src="/images/icons/facebook.webp" width="18" height="18" alt="Instagram" />Lace & Liora</a>
      <p>
        Stay connected with us for new arrivals, styling inspiration, and
        everyday moments from {{appname}}.
      </p>
    </li>
    <li>
      <h3><mat-icon fontIcon="location_on"></mat-icon> Mailing Address</h3>
      <p>{{address1}}<br />{{address2}}</p>
      <p class="note">
        Please note: This address is for mailing correspondence only. For
        customer support, please contact us by email.
      </p>
    </li>
    <li>
      <h3><mat-icon fontIcon="airplane_ticket"></mat-icon> Trade Shows</h3>
      <p>Coming Soon...</p>
      <p class="note">
        {{appname}} looks forward to connecting with our community, partners,
        and customers through future trade shows and events. Upcoming
        participation details will be updated here once confirmed.
      </p>
    </li>
  </ul>
</article>